/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import cx from 'classnames';
import mapboxgl from 'mapbox-gl';
import PropTypes from 'prop-types';
import { NoMapboxGlNotice } from 'sarsaparilla';

function LoadingSpinner({ mapRef, className, isMapLoaded }) {
    className = className || 'mapbox-basic-map';
    const modifierClass = !isMapLoaded ? 'loading' : '';

    if (!mapboxgl.supported()) {
        return <NoMapboxGlNotice />;
    }

    return (
        <div
            ref={mapRef}
            className={cx(
                'maps-loading-spinner',
                {
                    [`maps-loading-spinner--${modifierClass}`]: modifierClass,
                },
                { [className]: className }
            )}
        />
    );
}

LoadingSpinner.propTypes = {
    className: PropTypes.string,
    mapRef: PropTypes.func,
    isMapLoaded: PropTypes.bool,
};

export default LoadingSpinner;
